import PropTypes from "prop-types";

// @mui material components
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Icon from "@mui/material/Icon";
import Cookie from "js-cookie";
import { useNavigate } from "react-router-dom";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Custom styles for the SidenavCollapse
import {
  collapseItem,
  collapseIconBox,
  collapseIcon,
  collapseText,
} from "examples/Sidenav/styles/sidenavCollapse";

// Material Dashboard 2 React context
import { useMaterialUIController, setUser } from "context";
import { AUTH_STORAGE_KEY } from "constants/auth";
import { WidthFull } from "@mui/icons-material";

function SidenavLogout({ icon, name, active, ...rest }) {
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav, transparentSidenav, whiteSidenav, darkMode, sidenavColor } = controller;
  const navigate = useNavigate();
  const handleLogout = () => {
    Cookie.remove("access_token");
    Cookie.remove("jwt_token");
    Cookie.remove("hrms_token");
    localStorage.removeItem(AUTH_STORAGE_KEY);
    setUser(dispatch, null);
    navigate("/", { replace: true });
  };

  return (
    <ListItem component="li">
      <button
        style={{
          backgroundColor: "transparent",
          borderWidth: "0px",
          paddingLeft: "0px",
        }}
        onClick={handleLogout}
      >
        <MDBox
          {...rest}
          sx={(theme) =>
            collapseItem(theme, {
              active,
              transparentSidenav,
              whiteSidenav,
              darkMode,
              sidenavColor,
            })
          }
          WidthFull
        >
          <ListItemIcon
            sx={(theme) =>
              collapseIconBox(theme, { transparentSidenav, whiteSidenav, darkMode, active })
            }
          >
            {typeof icon === "string" ? (
              <Icon sx={(theme) => collapseIcon(theme, { active })}>{icon}</Icon>
            ) : (
              icon
            )}
          </ListItemIcon>
          <ListItemText
            primary={name}
            sx={(theme) =>
              collapseText(theme, {
                miniSidenav,
                transparentSidenav,
                whiteSidenav,
                active,
              })
            }
            style={{ paddingLeft: "0px" }}
          />
        </MDBox>
      </button>
    </ListItem>
  );
}

// Setting default values for the props of SidenavCollapse
SidenavLogout.defaultProps = {
  active: false,
};

// Typechecking props for the SidenavCollapse
SidenavLogout.propTypes = {
  icon: PropTypes.node.isRequired,
  name: PropTypes.string.isRequired,
  active: PropTypes.bool,
};

export default SidenavLogout;
